import { Button, styled } from '@acorns/web-components'

import { style } from 'theme'

export const Content = styled.div`
  max-width: 400px;
  margin: auto;

  .selection-list {
    margin: 30px auto 80px;
    box-shadow: ${style(theme => theme.shadows.lgMedium)};
    border-radius: ${style(theme => theme.borderRadius.large)};

    > div {
      padding-left: 18px;
      padding-right: 18px;
    }
  }
`

export const Heading = styled.div`
  font-size: 40px;
  line-height: 55px;
  color: ${style(theme => theme.colors.slate)};
  font-weight: 600;
  margin-top: 30px;
  margin-bottom: 10px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    font-size: 40px;
    line-height: 55px;
    margin: 10px 0;
  }
`

export const SubHeading = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 0 auto;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    font-size: 16px;
    line-height: 24px;
    padding-top: 10px;
  }
`

export const NextButton = styled(Button)`
  font-weight: 600;
  width: 220px;
  margin: auto;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`
export const OneTimeDepositButton = styled(Button)`
  height: 22px;
  position: relative;
  line-height: 22px;
  margin: 20px auto 0;
`
